<template>
  <div class="login">
    <header>
      <img class="login-img" src="./../../static/image/wxlogo.png">
    </header>
    <section>
      <form class="login-form">
        <div class="login-form-item">
          <div class="login-form-item-icon">
            <i class="iconfont icon-account icon_plain-primary"></i>
          </div>
          <div class="login-form-item-input"><input type="number" v-model="phone" oninput="if(value.length>11)value=value.slice(0,11)" placeholder="请输入手机号码" @focus="focus" @blur="blur" /></div>
        </div>
        <div class="login-form-item">
          <div class="login-form-item-icon">
            <i class="iconfont icon-password icon_plain-primary" aria-hidden="true"></i>
          </div>
          <div class="login-form-item-input"><input type="password" v-model="password" placeholder="请输入密码" @focus="focus" @blur="blur"  @keyup.enter="bind"/></div>
        </div>
      </form>
      <a href="javascript:void(0)" class="login-form-submit weui-btn weui-btn_plain-primary weui-btn_loading" v-on:click="bind">
        <i class="weui-loading" v-show="isLoading"></i>绑定账号</a>
    </section>

    <div class="weui-footer" v-if="!isCoding">
      <p class="weui-footer__links">
        <a href="javascript:void(0);" class="weui-footer__link">校圆通</a>
      </p>
      <p class="weui-footer__text">Copyright &copy; 2017-{{year}} aixyt.com</p>
    </div>
  </div>
</template>

<script>
import config from "@/config/config";
import weui from "weui.js";
import axios from "axios";
import moment from "moment";

export default {
  data() {
    return {
      redirect: "",
      encodeToken: "",
      token: "",
      userInfo: {},
      phone: "",
      password: "",
      isLoading: false,
      year: moment().format('YYYY'),
      isCoding: false
    };
  },
  created() {
    this.redirect = this.$route.params.redirect;
    this.encodeToken = this.$route.params.token;
    this.token = decodeURIComponent(this.encodeToken);
    axios.defaults.headers["Authorization"] = "Bearer " + this.token;
    this.phone = localStorage.getItem("loginPhone");

    // 根据token查找微信用户信息
    axios
      .get("/api/user/wxuserInfo")
      .then(response => {
        this.userInfo = response.data.data;
      })
      .catch(error => {
        weui.topTips("获取用户信息失败", 2000);
      });
  },
  methods: {
    focus() {
      this.isCoding = true;
    },
    blur() {
      this.isCoding = false;
    },
    bind() {
      let that = this;
      this.isLoading = !this.isLoading;
      if (!this.phone) {
        weui.topTips("电话号码不能为空", {
          duration: 1000,
          callback: function() {
            that.isLoading = !that.isLoading;
          }
        });
      } else if (this.phone.length != 11) {
        weui.topTips("电话号码格式不对", {
          duration: 1000,
          callback: function() {
            that.isLoading = !that.isLoading;
          }
        });
      } else if (!this.password) {
        weui.topTips("密码不能为空", {
          duration: 1000,
          callback: function() {
            that.isLoading = !that.isLoading;
          }
        });
      } else {
        var NodeRSA = require("node-rsa");
        let pubKey = new NodeRSA(config.pubKey);
        let encryptPassword = pubKey.encrypt(this.password, "base64");

        let params = {
          phone: this.phone,
          password: encryptPassword,
          openid: this.userInfo.openid
        };
        axios
          .get("auth/employee/wxlogin", { params })
          .then(response => {
            if (!response.data.success) {
              weui.topTips("手机号码或者密码错误", {
                duration: 1000,
                callback: function() {
                  that.isLoading = !that.isLoading;
                }
              });
            } else {
              that.isLoading = !that.isLoading;
              sessionStorage.setItem("token", response.data.token);
              sessionStorage.setItem(
                "userInfo",
                JSON.stringify(response.data.data)
              );
              localStorage.setItem("loginPhone", this.phone);
              this.$router.push("/"+this.redirect+'/'+this.encodeToken);
            }
          })
          .catch(error => {
            weui.topTips(error, {
              duration: 1000,
              callback: function() {
                that.isLoading = !that.isLoading;
              }
            });
          });
      }
    }
  }
};
</script>

<style scoped>
.login {
  font-size: 18px;
  padding-top: 40px;
}
header {
  text-align: center;
}
.login-img {
  width: 50%;
  max-width: 140px;
}
.login-form {
  width: 80%;
  margin: 0 auto;
  margin-top: 50px;
}
.login-form-item {
  display: flex;
  position: relative;
  height: 36px;
  line-height: 36px;
  margin-top: 10px;
}
.login-form-item + .login-form-item {
  margin-top: 20px;
}
.login-form-item:before {
  content: "";
  position: absolute;
  bottom: -8px;
  left: 0px;
  width: 100%;
  border-bottom: 1px solid #ddd;
  opacity: 0.63;
}
.login-form-item i {
  font-size: 25px;
}
.login-form-item input {
  display: block;
  padding: 8px 0px;
  width: 100%;
  border: 0px;
  font-size: 18px;
  border-left: 1px solid #ddd;
  padding-left: 15px;
  position: relative;
}
.icon_plain-primary {
  color: #1aad19;
}
.login-form-item-icon {
  width: 50px;
  text-align: center;
}
.login-form-item-input {
  flex: 1;
}
.login-form-submit {
  width: 80%;
  margin-top: 40px;
}
.weui-footer {
  position: fixed;
  bottom: 10px;
  left: 0px;
  right: 0px;
  text-align: center;
  margin-left: auto;
  margin-right: auto;
}
</style>


// WEBPACK FOOTER //
// src/components/Login.vue